import { Combobox } from '@f/elements/HookForm/Combobox'
import { FormDatePicker } from '@f/elements/HookForm/FormDatePicker'
import { FormTimePicker } from '@f/elements/HookForm/FormTimePicker'
import { PhoneInput } from '@f/elements/HookForm/PhoneInput'
import { FormSlider } from '@f/elements/HookForm/Slider'

import { Checkbox, CheckboxWithImageLabel } from './Checkbox'
import { HookFormText } from './FormText'
import { ConnectForm, FormWrapper } from './FormWrapper'
import { MirrorInput } from './MirrorInput'
import { RadioInput } from './RadioInput'
import { Select } from './Select'
import { TextArea } from './TextArea'

export const Form = {
  Wrapper: FormWrapper,
  Text: HookFormText,
  Radio: RadioInput,
  Select: Select,
  TextArea: TextArea,
  Phone: PhoneInput,
  ConnectForm: ConnectForm,
  Checkbox: Checkbox,
  CheckboxWithImageLabel: CheckboxWithImageLabel,
  Slider: FormSlider,
  Combobox: Combobox,
  DatePicker: FormDatePicker,
  TimePicker: FormTimePicker,
  MirrorInput: MirrorInput
}
